import { render, staticRenderFns } from "./VimeoCard.vue?vue&type=template&id=3c1367a6"
import script from "./VimeoCard.vue?vue&type=script&lang=js"
export * from "./VimeoCard.vue?vue&type=script&lang=js"
import style0 from "./VimeoCard.vue?vue&type=style&index=0&id=3c1367a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports